const BasketFields = {
  ITEMS: 'items',
};

export default BasketFields;
